export const FeatureSwitchTypes = {
  Basic: 'Basic',
  Percentage: 'Percentage',
  UserList: 'User List',
  Subscription: 'Subscription',
};

type FeatureSwitchType =
  (typeof FeatureSwitchTypes)[keyof typeof FeatureSwitchTypes];

export enum FeatureSwitchEnum {
  Basic = 'Basic',
  Percentage = 'Percentage',
  UserList = 'User List',
  Subscription = 'Subscription',
}

export type FeatureSwitchFlag = {
  enabled: boolean;
  switch_type: FeatureSwitchType;
  value: string;
};

// Update FeatureSwitch to use the enum
export type FeatureSwitch = {
  id: string;
  switch_name: string;
  switch_type: FeatureSwitchEnum;
  enabled: boolean;
  value: string;
};
